import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Orders } from 'models/OrdersModel';
import { Statement } from 'models/StatementModel';


const OrderList: React.FC = () => {
  const width = { sno: 12, client:28, amount: 12, status:16,  date: 16, createdby: 16 }
  const [formId, formName] = [Code.Form.Id.ORDERS, Code.Form.Name.ORDERS];
  const {loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [orderData, setOrderData] = useState<Orders[]>([]); 
  const [statementData, setStatementData] = useState<Statement[]>([]); 
  const [selectedOrder, setselectedOrder] = useState<Orders | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const [locationId, setLocationId] = useState<number>(Utility.Storage.LocationId());
  const [statusId, setStatusId] = useState<number>(Code.Option.Common.ALL);
  const [locationOptions, setLocationOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const triggers = [pno, rows, search, activeId, userId, statusId, locationId];
  const Privilege = Hooks.Privilege.List(formId);

  const [dashOrdered, setDashOrdered] = useState<number>(0);
  const [dashOrderPlaced, setDashOrderPlaced] = useState<number>(0);
  const [dashSentToLab, setDashSentToLab] = useState<number>(0);
  const [dashReceived, setDashReceived] = useState<number>(0);
  const [dashArrivedVerified, setDashArrivedVerified] = useState<number>(0);
  const [dashPxNotified, setDashPxNotified] = useState<number>(0);
  const [dashPxLeftMessage, setDashPxLeftMessage] = useState<number>(0);
  const [dashOthers, setDashOthers] = useState<number>(0);

  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.API(Code.File.LOCATION, Code.Option.Common.NOTHING, setLocationOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.ORDER_STATUS, Code.Option.Common.ALL, setStatusOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    if(statementData){
      const dataMap = new Map(statementData.map(item => [item.statement_id, Number(item.statement_value1) || 0]));

      setDashOrdered(dataMap.get(Number(Code.Option.Action.ORDERED)) ?? 0);
      setDashOrderPlaced(dataMap.get(Number(Code.Option.Action.ORDERPLACED)) ?? 0);
      setDashSentToLab(dataMap.get(Number(Code.Option.Action.SENTTOLAB)) ?? 0);
      setDashReceived(dataMap.get(Number(Code.Option.Action.RECEIVED)) ?? 0);
      setDashArrivedVerified(dataMap.get(Number(Code.Option.Action.ARRIVEDVERIFIED)) ?? 0);
      setDashPxNotified(dataMap.get(Number(Code.Option.Action.PXNOTIFIED)) ?? 0);
      setDashPxLeftMessage(dataMap.get(Number(Code.Option.Action.PXLEFTMESSAGE)) ?? 0);
    }
    console.log("statementData----->",statementData);
  }, [statementData]);

  useEffect(() => {
    onReload();
  }, triggers);

  const onReload = () => {
    //getDashList();
    callListData(); 
  };

  const getDashList = useCallback(async () => {
    const url = `custom/orders/count/${locationId}`;
    await API.Data.List<Statement>(url, setStatementData, setError, setLoading);
  }, []);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Orders.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Orders.Number, 
        Name.Orders.Date, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.Orders.Net,
        Name.Common.StatusName,
        Name.User.FullName,
        Name.Sale.Id
      ]),
      user_id: userId,
      status_id: statusId,
      location_id: locationId,
    });
    await API.Data.List<Orders>(url, setOrderData, setError, setLoading); 
  }, triggers);



  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.DashList data={[
          [1, "Ordered", dashOrdered], 
          [2, "Order Placed", dashOrderPlaced], 
          [3, "Sent to Lab", dashSentToLab], 
          [4, "Received", dashReceived], 
          [5, "Arrived & Verified", dashArrivedVerified], 
          [6, "Px Notified", dashPxNotified],
          [7, "Px Left Message", dashPxLeftMessage],
          [8, "Others", dashOthers]
        ]} />
        <Control.List.DashTool>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Location} options={locationOptions} onChange={setLocationId} />
              <Control.Dropdown title={Title.Status} options={statusOptions} onChange={setStatusId} />
              <Control.Dropdown title={Title.User} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.DashTool>
        <Control.List.DashData>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, orderData, setSelectAllChecked,formName)} extra={3} />
              <Control.Grid.Items values={[
                [Title.SNo, width.sno], 
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.State, width.status],
                [Title.Date, width.date],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(orderData) && (
              <Control.Grid.Row>
                {orderData.map((orderData) => { return (
                  <Control.Grid.Data<Orders> key={orderData.orders_id} itemKey={orderData.orders_key} data={orderData} setMenuPosition={setMenuPosition} setSelectedData={setselectedOrder} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={orderData.orders_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, orderData.orders_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, orderData.orders_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Sale path={Utility.Join.Edit(Privilege, Code.Form.Name.SALE, orderData.sale_id)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Text value={orderData.orders_number} width={width.sno} />
                    <Control.Grid.Link value={Utility.Get.FullName(orderData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(Privilege, Code.Form.Name.CLIENT, orderData.client_id)} width={width.client} iframeRef={iframeRef} />
                    <Control.Grid.Items values={[
                      [Utility.Format.Amount(orderData.orders_net_amount), width.amount, Code.Align.RIGHT],
                      [orderData.status_name, width.status], 
                      [Utility.Format.DateOnly(orderData.orders_date), width.date], 
                      [Utility.Get.FullName(orderData,Code.Form.Name.USER), width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={orderData.orders_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.DashData>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={orderData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedOrder?.orders_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedOrder?.orders_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={onReload} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default OrderList;